var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivered2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2222 4.08738L10.0739 7.53405C7.96552 8.32238 6.24219 10.8157 6.24219 13.0524V26.674C6.24219 28.8374 7.67219 31.679 9.41385 32.9807L17.2972 38.8657C19.8822 40.8091 24.1355 40.8091 26.7205 38.8657L34.6039 32.9807C36.3455 31.679 37.7755 28.8374 37.7755 26.674V13.0524C37.7755 10.7974 36.0522 8.30405 33.9439 7.51572L24.7955 4.08738C23.2372 3.51905 20.7439 3.51905 19.2222 4.08738Z",
    stroke: "#219EBC",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0601 18.6253V16.2933H19.1227V27H16.5121V18.6253H15.0601ZM29.1544 18.816L24.0211 30.8867H21.3224L23.1997 26.7213L19.8704 18.816H22.6717L24.5637 23.9347L26.4411 18.816H29.1544Z",
    fill: "#219EBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered2);
export default __webpack_public_path__ + "static/media/delivered2.bdad44374191dcea24fa714f28926d18.svg";
export { ForwardRef as ReactComponent };